export const MSGS = {
  PERMISSAO_NEGADA: 'Acesso não permitido.',
  SESSAO_EXPIRADA: 'Sessão expirada.',
  ERRO_PADRAO: 'Ocorreu um erro. Tente novamente.',
  ERRO_INTERNO: 'Erro interno do servidor. Tente novamente.',
  NAO_ENCONTRADO: (page = 'Recurso') => `${page} não encontrado.`,
  FALHA_CARREGAR: (page = 'os dados') => `Não foi possível carregar ${page}.`,
};
